/* ============
 * Actions for the account module
 * ============
 *
 * The actions that are available on the
 * account module.
 */

import * as types from './mutation-types';
import Vue from 'vue';

export const store = ({ commit }, payload) => {
  commit(types.STORE, payload);
};

export const getAccount = ({ commit }, token) => {
  const requestConfig = token ? { headers: { Authorization: token } } : {};

  Vue.$http
    .get('users/me', requestConfig)
    .then((response) => {
      const user = response.data.user;
      commit(types.GET_ACCOUNT, user);
    })
    .catch((error) => {
      console.log(error);
    });
};


export default {
  store,
  getAccount,
};



// WEBPACK FOOTER //
// ./src/store/modules/account/actions.js